export enum ResourceEntityType {
	Calendar = 'calendar',
	Sku = 'sku',
}
